// canvas font size (responsive)
// export function getFontSize({contentWidth, contentHeight}, value = 16) {
//   return (contentWidth + contentHeight) / 200 * value
// }

export function getFontSize({ contentWidth }, { width }, value = 16) {
  const ratios = {
    '200': width < 5,
    '300': 5 <= width && width < 9,
    '400': 9 <= width
  }
  const result = Object.entries(ratios).filter(([key, value]) => value).at(0)

  return contentWidth / (result ? parseInt(result.at(0)) : 200) * value
}

export function getChartFontSize(width, value = 10) {
  return width / 100 * value
}

export function getThisYear() {
  return new Date().getFullYear().toString()
}

// mock data (random value)
export function getRandomValue(min = 1, max = 100) {
  const value = Math.floor(Math.random() * (max - min + 1) + min)
  return value
}

// canvas context align, font setting
function setTextOptions(context, options = {}) {
  context.textAlign = options.align || 'start'
  context.textBaseline = options.baseline || 'top'
  context.font = options.font || 'bold 32px sans-serif'
}


export function calculateYAxisMax(data) {
  const numericData = data.map(value => parseFloat(value)).filter(value => value >= 0);  // 데이터를 숫자로 변환
    const maxValue = Math.max(...numericData);  // 최대값 계산

      // Y축 눈금 간격을 동적으로 결정
      let stepSize;
  
      // maxValue에 따라 stepSize 계산 (10의 제곱수를 기준으로 결정)
      if (maxValue > 1000) {
          stepSize = 200;  // 최대값이 1000억 초과 시 200억 단위
      } else if (maxValue > 500) {
          stepSize = 100;  // 최대값이 500억 초과 시 100억 단위
      } else if (maxValue > 100) {
          stepSize = 40;  // 최대값이 100억 초과 시 40억 단위
      } else if (maxValue > 50) {
          stepSize = 10;  // 최대값이 50억 초과 시 10억 단위
      } else {
          stepSize = 5;   // 그 외는 5억 단위
      }
  
      // Y축 최대값을 stepSize의 배수로 설정
      const roundedMax = Math.ceil(maxValue / stepSize) * stepSize;
  
      return {
          max: roundedMax,  // 계산된 최대값
          stepSize: stepSize  // 계산된 stepSize
      };
}

// draw text
export function drawText(context, options = {}) {
  setTextOptions(ctx)
  context.fillText(...options.draw)
}

// 3 comma
export function numberFormatter(value) {
  if (isNaN(value)) {
    return value
  }else if(typeof value === 'number'){
    value = value.toString()
  }
  return value.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
}

// doughnut chart default options
export const defaultOptions = {
  doughnut: {
    devicePixelRatio: 1,
    aspectRatio: 1.5,
    layout: {
      padding: {
        top: 20,
      }
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        align: "start",
        labels: {
          boxWidth: 10,
          boxHeight: 10,
          generateLabels: (chart) => {
            return chart.data.labels.map((label, index) => {
              return {
                text: label,
                fontColor: `#333`,
                fillStyle: chart.data.datasets[0].backgroundColor.at(index),
                lineWidth: 0,
              }
            })
          }
        },
        fullSize: false,
      },
      tooltip: {
        enabled: false,
        displayColors : false, 
      }
    }
  },
  line: {
    indexAxis: "x",
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value, index, ticks) {
            return `${value}억`;
          }
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        align: "start",
        labels: {
          boxWidth: 10,
          boxHeight: 10,
          generateLabels: (chart) => {
            return [
              {
                text: 'REV',
                fontColor: `#333`,
                fillStyle: "rgba(75, 192, 192, 0.8)",
                lineWidth: 0,
              },
              {
                text: 'GM',
                fontColor: `#333`,
                fillStyle: "rgba(75, 192, 192, 0.8)",
                lineWidth: 0,
              },
            ]
          }
        }
      },
      tooltip: {
        usePointStyle: true,
        callbacks: {
          labelPointStyle() {
            return {
              pointStyle: false,
            };
          },
          title([data]) {
            return `Total Rev. FCST ${data.raw}억원`
          },
          label(data) {
            return fetchedData.value.additionalData.tooltip[data.label]
          }
        }
      }
    }
  },
  bar: {
    devicePixelRatio: 1,
    layout: {
      padding: {
        top: 50,
      }
    },
    indexAxis: "x",
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value, index, ticks) {
            return `${value}억`;
          }
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        align: "start",
        labels: {
          boxWidth: 10,
          boxHeight: 10,
          generateLabels: (chart) => {
            return chart.data.labels.map((label, index) => {
              return {
                text: label,
                fontColor: `#333`,
                fillStyle: chart.data.datasets[0].backgroundColor.at(index),
                lineWidth: 0,
              }
            })
          }
        }
      }
    }
  },
  vertical: {
    devicePixelRatio: 1,
    maintainAspectRatio: false,
    responsive: true,
    layout: {
      padding: {
        top: 60,
      }
    },
    indexAxis: "x",
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value, index, ticks) {
            return `${value}억`;
          }
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        align: "start",
        labels: {
          boxWidth: 10,
          boxHeight: 10,
          generateLabels: (chart) => {
            return chart.data.labels.map((label, index) => {
              return {
                text: label,
                fontColor: `#333`,
                fillStyle: chart.data.datasets[0].backgroundColor.at(index),
                lineWidth: 0,
              }
            })
          }
        },
        onClick: () => false
      },
      tooltip: {
        displayColors : false,
      }
    }
  },
  horizontal: {
    devicePixelRatio: 1,
    maintainAspectRatio: false,
    responsive: true,
    indexAxis: "y",
    layout: {
      padding: {
        right: 70,
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          callback: function (value, index, ticks) {
            return `${value}억`;
          }
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        align: "start",
        labels: {
          boxWidth: 10,
          boxHeight: 10,
          generateLabels: (chart) => {
            return chart.data.labels.map((label, index) => {
              return {
                text: label,
                fontColor: `#333`,
                fillStyle: chart.data.datasets[0].backgroundColor.at(index),
                lineWidth: 0,
              }
            })
          },
        },
        onClick: () => false
      },
      tooltip: {
        displayColors : false,
      }
    }
  }
}

export function FCSTMapper(result, title, labels) {
  if (!result.rtn.length) {
    return {
      data: [0],
      rawData: [0],
      dataPer: [0],
      centerValue: [0, 0, 0]
    }
  }
  const mappedResult = result.rtn.filter(item => item.title === title)
    .sort((a, b) => {
      function getIndex(itemname) {
        return labels.findIndex(label => label === itemname)
      }
      return getIndex(a.itemname) - getIndex(b.itemname)
    })
  const data = mappedResult.map(item => {
    const less10 = parseFloat(item.itemxper) < 7 ? '7' : item.itemxper
    return less10
  })
  const rawData = mappedResult.map(item => {

    return parseFloat(item.itemsumdecimal) < 7 ? '7' : item.itemsumdecimal
  })
  const realData = mappedResult.map(item => {
    return item.itemsumdecimal
  })
  const dataPer = mappedResult.map(item => {
    return item.itemxper
  })

  return { data, rawData, dataPer, centerValue: [mappedResult.at(0)?.allsumdecimal || 0, mappedResult.at(0)?.quotavalue || 0, mappedResult.at(0)?.wowvalue || 0],realData}
}